module.exports = __webpack_public_path__ + "69e1b350d29164f7bd8516e1bd5d2f1b.svg";